import { ICreateOutputItem } from "Dashboard/scenes/Stock/domain/ICreateOutputItem";
import { stockService } from "Dashboard/scenes/Stock/services/stock.service";
import { useEffect, useState } from "react";
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue
} from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FormatDateIso } from "utils/dateUtils";
import { selectState } from "../../Input/inputSlice";
import "../output-dialog.scss";
import { useAppDispatch } from "hooks/hooks";
import { resetOutputValue } from "../../Input/inputSlice";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import { useSelector } from "react-redux";
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesStock from "Dashboard/scenes/Stock/popover.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EmployeeSelect from "Dashboard/scenes/Resources/components/EmployeeSelect";
import { IStockOutputForEmployeeCreate } from "Dashboard/scenes/Stock/domain/IStockOutputForEmployeeCreate";
import DatePicker from "react-datepicker";

interface IProps {
  handleSubmit: UseFormHandleSubmit<IStockOutputForEmployeeCreate>;
  setValue: UseFormSetValue<IStockOutputForEmployeeCreate>;
  register: UseFormRegister<IStockOutputForEmployeeCreate>;
  getValues: UseFormGetValues<IStockOutputForEmployeeCreate>;
  control: Control<IStockOutputForEmployeeCreate, any>;
  errors: Partial<FieldErrorsImpl<IStockOutputForEmployeeCreate>>;
  reset: () => void;
};

const NewStockOutputToEmployeePopover = (props: IProps) => {
  const resetForm = () => {
    reset();
  };

  const closeDialog = () => {
    resetForm();
  };

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const [billOfLandingSequence, setBillOfLandingSequence] = useState(0);
  const [requisitionSequence, setRequisitionSequence] = useState(0);

  const {
    register,
    handleSubmit,
    control,
    errors,
    reset,
  } = props;

  const {
    outputValues: { map, repository },
  } = useSelector(selectState);

  const onSubmit = async (data: IStockOutputForEmployeeCreate) => {
    const outputItems: ICreateOutputItem[] = [];
    for (const [key, value] of Object.entries(map)) {
      outputItems.push({
        inputId: Number(key),
        quantityAmount: value || 0,
      });
    }

    try {
      await stockService.createOutputEmployee("Lager", {
        repositoryId: data.repositoryId,
        note: data.note,
        outputForEmployeeId: data.outputForEmployeeId,
        date: data.date,
        items: outputItems,
      });
      navigate("/stock/output");
      toast.success("Izdavanje je uspesno izvrseno.");
      dispatch(resetOutputValue());
      closeDialog();
    } catch (err: any) {
      if (err.response.status === 407) {
        toast.error("Izdavanje nije izvršeno jer neki uneseni podaci nisu ispravni");
      } else if (err.response.status === 403) {
        toast.error("Nije dozvoljeno izdavanje lagera (da li ste zaposleni u firmi?)");
      }
    }
  };

  useEffect(() => {
    async function getData() {
      if (repository) {
        const rep = await stockService.getRepositoryForStock(
          "Lager",
          repository.repositoryId
        );
        setBillOfLandingSequence(rep.billOfLandingSequence);
        setRequisitionSequence(rep.requisitionSequence);
      }
    }
    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, [repository]);

  return (
    <form
      className={`
      ${classesStock.newStockOutputPopover} 
      ${classes.basicPopoverView}
      ${classes.gPopoverInputs}
      `}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className={classes.subInputs}>
        <div>
          <label>magacin</label>
          <div>
            <input type="text" className={classes.dotField}
              value={repository?.name} disabled />
          </div>
          <input type="hidden" className={classes.dotField}
            value={repository?.repositoryId}
            {...register("repositoryId", { valueAsNumber: true })}
          />
        </div>
      </div>

      <div className={classes.subInputs}>
        <div>
          <label>sledeći br otpremnice</label>
          <div>
            <input type="text" className={classes.dotField}
              value={billOfLandingSequence} disabled />
          </div>
        </div>
      </div>

      <div className={classes.subInputs}>
        <div>
          <label>sledeći br trebovanja</label>
          <div>
            <input type="text" className={classes.dotField}
              value={requisitionSequence} disabled />
          </div>
        </div>
      </div>

      <div
        className={`${errors.outputForEmployeeId ? classes.inputError : ""}`}
      >
        <div>
          <label>izdajem zaposlenom</label>
          <Controller
            name="outputForEmployeeId"
            control={control}
            defaultValue={undefined}
            rules={{
              required: true,
            }}
            render={({ field: { onChange } }) => (
              <EmployeeSelect
                customStyles={styles.customStyleClassic}
                error={errors.outputForEmployeeId}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div>
        <div>
          <label>napomena</label>
          <textarea {...register("note")} />
        </div>
      </div>

      <div>
        <div>
          <label>datum</label>
          <div className={classesStock.calendarContainer}>
            <Controller
              control={control}
              name="date"
              defaultValue={FormatDateIso(new Date())}
              rules={{ required: true }}
              render={({ field: { onChange, value } }) => (
                <div>
                  <DatePicker
                    onChange={(date) =>
                      onChange(date ? FormatDateIso(date) : undefined)
                    }
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="dd.MM.yyyy"
                    selected={value ? new Date(value) : null}
                    className={`${errors.date ? classes.itemError : ""}`}
                  />
                </div>
              )}
            />
          </div>
        </div>
      </div>

      <div className={`${classes.buttons}`}>
        <button className={classes.iconButton} type="submit">
          <FontAwesomeIcon
            icon={faLongArrowAltDown}
            className={classes.icon} />
        </button>
      </div>
    </form>
  );
};

export default NewStockOutputToEmployeePopover;
